var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 12,
    fill: "#F7931A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9739 14.6281C21.1819 13.1571 20.123 12.3663 18.6749 11.8388L19.1447 9.84609L17.9978 9.54383L17.5405 11.4841C17.2389 11.4045 16.9293 11.3296 16.6216 11.2553L17.0822 9.30225L15.936 9L15.4659 10.992C15.2164 10.932 14.9714 10.8726 14.7336 10.81L14.7349 10.8037L13.1533 10.386L12.8482 11.6816C12.8482 11.6816 13.6991 11.8879 13.6812 11.9006C14.1456 12.0232 14.2296 12.3484 14.2157 12.6061L13.6806 14.8762C13.7126 14.8848 13.754 14.8973 13.7998 14.9167L13.7665 14.9079C13.7382 14.9004 13.7088 14.8926 13.6786 14.885L12.9286 18.0652C12.8718 18.2144 12.7277 18.4384 12.403 18.3533C12.4145 18.3709 11.5694 18.1333 11.5694 18.1333L11 19.5218L12.4925 19.9153C12.656 19.9587 12.8175 20.0032 12.9774 20.0473L12.9775 20.0473C13.0892 20.0781 13.2001 20.1087 13.3102 20.1385L12.8356 22.154L13.9812 22.4563L14.4512 20.4621C14.7642 20.552 15.0679 20.6349 15.3652 20.713L14.8968 22.6977L16.0438 23L16.5184 20.9882C18.4741 21.3797 19.9447 21.2219 20.5636 19.351C21.0624 17.8447 20.5388 16.9758 19.5099 16.4092C20.2593 16.2264 20.8238 15.7051 20.9743 14.6283L20.9739 14.628L20.9739 14.6281ZM18.3537 18.5144C18.0285 19.8964 15.9832 19.3251 15.0474 19.0637C14.9632 19.0401 14.888 19.0191 14.8238 19.0023L15.4536 16.332C15.5318 16.3527 15.6274 16.3754 15.7357 16.4011C16.7036 16.6308 18.6869 17.1015 18.3538 18.5144H18.3537ZM15.9299 15.1604C16.71 15.3806 18.412 15.861 18.7084 14.6049H18.7085C19.0112 13.3203 17.3572 12.933 16.5493 12.7438C16.4585 12.7226 16.3783 12.7038 16.3128 12.6865L15.7418 15.1083C15.7957 15.1225 15.859 15.1404 15.9299 15.1604Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.8ec5850788187c1ef43fd960f0119918.svg";
export { ForwardRef as ReactComponent };